import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractDialogComponent } from '@motivforce/mx-library-angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-full-cart-dialog',
  templateUrl: './full-cart-dialog.component.html',
  styleUrls: ['./full-cart-dialog.component.scss'],
})
export class FullCartDialogComponent extends AbstractDialogComponent {
  constructor(public activeModal: NgbActiveModal, private router: Router) {
    super();
  }

  onConfirm(): void {
    this.activeModal.close();
    this.router.navigateByUrl('/rewards-catalogue/cart');
  }
}
